// extracted by css-extract-rspack-plugin
export default {"offScreenHydration":"offScreenHydration-UhXMzZ"};